import React, { useState } from "react";
import { FiX, FiChevronDown, FiHelpCircle } from "react-icons/fi";

const Optoutmodal = ({ show, handleClose, onSave }) => {
  const [formData, setFormData] = useState({
    triggerType: "",
    button: "",
    acknowledgeMessage: true,
    message: "You have been unsubscribed from our messages. Reply 'START' anytime to resubscribe."
  });

  const triggerOptions = [
    { value: "button_click", label: "Button Click" },
    { value: "keyword", label: "Keyword Match" },
    { value: "any_reply", label: "Any Reply" }
  ];

  const buttonOptions = [
    { value: "opt_out", label: "Opt Out Button" },
    { value: "stop", label: "Stop Button" },
    { value: "unsubscribe", label: "Unsubscribe Button" }
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
    handleClose();
  };

  return (
    <div className={`modal fade ${show ? "show d-block" : ""}`} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content border-0 shadow" style={{overflowY:'auto'}}>
          <div className="modal-header bg-danger text-white">
            <h5 className="modal-title">Opt-out Configuration</h5>
            <button type="button" className="btn-close btn-close-white" onClick={handleClose}>
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="alert alert-info d-flex align-items-center">
                <FiHelpCircle className="me-2" />
                <small>
                  When triggered, this will update the customer's "WhatsApp Opted" status to false.
                  <a href="#" className="ms-1">Learn more</a>
                </small>
              </div>

              <div className="mb-4">
                <label className="form-label fw-bold d-block mb-2">Trigger Condition</label>
                <select 
                  name="triggerType"
                  value={formData.triggerType}
                  onChange={handleChange}
                  className="form-select form-select-lg"
                  required
                >
                  <option value="">Select trigger condition</option>
                  {triggerOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>

              {formData.triggerType === "button_click" && (
                <div className="mb-4">
                  <label className="form-label fw-bold d-block mb-2">Select Button</label>
                  <select 
                    name="button"
                    value={formData.button}
                    onChange={handleChange}
                    className="form-select form-select-lg"
                    required
                  >
                    <option value="">Select button</option>
                    {buttonOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>
              )}

              {formData.triggerType === "keyword" && (
                <div className="mb-4">
                  <label className="form-label fw-bold d-block mb-2">Keywords (comma separated)</label>
                  <input
                    type="text"
                    name="keywords"
                    value={formData.keywords || ""}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="stop, unsubscribe, cancel"
                    required
                  />
                </div>
              )}

              <div className="mb-3">
                <div className="form-check form-switch">
                  <input
                    type="checkbox"
                    name="acknowledgeMessage"
                    className="form-check-input"
                    id="acknowledgeMsg"
                    checked={formData.acknowledgeMessage}
                    onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor="acknowledgeMsg">
                    Send acknowledgment message
                  </label>
                </div>
              </div>

              {formData.acknowledgeMessage && (
                <div className="mb-3">
                  <label className="form-label fw-bold d-block mb-2">Acknowledgment Message</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-control"
                    rows="3"
                    required
                  ></textarea>
                  <small className="text-muted">Max 256 characters</small>
                </div>
              )}
            </div>

            <div className="modal-footer border-top-0">
              <button type="button" className="btn btn-outline-secondary" onClick={handleClose}>
                Cancel
              </button>
              <button type="submit" className="btn btn-danger">
                Save Configuration
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Optoutmodal;